@if (loginFailed()) {
  <p>{{ 'onegate.login.error.title' | translate }}</p>
} @else if (user$ | async) {
  <router-outlet />
}
